import config from '@/config'
import { setup } from '@sjzy/library'
import '@sjzy/library/dist/style.css'

export function setupSjzyLibrary() {
  setup({
    mode: import.meta.env.MODE,
    systemKey: config.systemKey,
  })
}
